"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMatchIndexProp = exports.default = exports.HighlightedText = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _isInteger = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-integer"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _escapeRegExp = _interopRequireDefault(require("lodash/escapeRegExp"));
var _styles = require("./styles");
/**
 * Renders the display text for a select item.
 * Item text that matches the input value is bolded when not using dropdown mode.
 */
const ItemText = _ref => {
  let {
    children,
    inputValue,
    useTypeahead,
    truncate
  } = _ref;
  const text = useTypeahead ? /*#__PURE__*/_react.default.createElement(HighlightedText, {
    substring: inputValue
  }, children) : children;
  return truncate ? /*#__PURE__*/_react.default.createElement(_styles.TruncatedSpan, null, text) : /*#__PURE__*/_react.default.createElement("span", null, text);
};
const HighlightedText = _ref2 => {
  let {
    children,
    substring,
    startIndex,
    endIndex
  } = _ref2;
  if (typeof substring === 'string') {
    substring = (0, _escapeRegExp.default)(substring);
    startIndex = children.toLowerCase().search(substring.toLowerCase());
    endIndex = startIndex + substring.length;
  }
  const beforeMatchingText = (0, _slice.default)(children).call(children, 0, startIndex);
  const matchingText = (0, _slice.default)(children).call(children, startIndex, endIndex);
  const afterMatchingText = (0, _slice.default)(children).call(children, endIndex);
  return startIndex >= 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, beforeMatchingText, /*#__PURE__*/_react.default.createElement("strong", null, matchingText), afterMatchingText) : children;
};
exports.HighlightedText = HighlightedText;
const validateMatchIndexProp = (props, propName, _componentName) => {
  if (propName in props) {
    if ('substring' in props) {
      return new Error('Cannot supply `substring` and `' + propName + '`.');
    } else if (!(0, _isInteger.default)(props[propName])) {
      return new Error('Expected `' + propName + '` to be an integer.');
    }
  }
};
exports.validateMatchIndexProp = validateMatchIndexProp;
HighlightedText.propTypes = {
  /**
   * The html children of this component; i.e., the text to highlight.
   */
  children: _propTypes.default.string,
  /**
   * (Optional) A substring to match and highlight (case-insensitively).
   * Only the first matching substring in `children` will be highlighted.
   * If specified, neither `startIndex` nor `endIndex` may be specified.
   */
  substring: _propTypes.default.string,
  /**
   * (Optional) String index of `children` to begin highlighting (inclusive).
   * If specified, `endIndex` must also be specified.
   */
  startIndex: validateMatchIndexProp,
  /**
   * (Optional) String index of `children` to end highlighting (exclusive).
   * If specified, `startIndex` must also be specified.
   */
  endIndex: validateMatchIndexProp
};
var _default = exports.default = ItemText;
HighlightedText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HighlightedText",
  "props": {
    "children": {
      "description": "The html children of this component; i.e., the text to highlight.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "substring": {
      "description": "(Optional) A substring to match and highlight (case-insensitively).\nOnly the first matching substring in `children` will be highlighted.\nIf specified, neither `startIndex` nor `endIndex` may be specified.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "startIndex": {
      "description": "(Optional) String index of `children` to begin highlighting (inclusive).\nIf specified, `endIndex` must also be specified.",
      "type": {
        "name": "custom",
        "raw": "validateMatchIndexProp"
      },
      "required": false
    },
    "endIndex": {
      "description": "(Optional) String index of `children` to end highlighting (exclusive).\nIf specified, `startIndex` must also be specified.",
      "type": {
        "name": "custom",
        "raw": "validateMatchIndexProp"
      },
      "required": false
    }
  }
};
ItemText.__docgenInfo = {
  "description": "Renders the display text for a select item.\nItem text that matches the input value is bolded when not using dropdown mode.",
  "methods": [],
  "displayName": "ItemText"
};